import type { GlossaryProps } from "@op/puck-types";

const Glossary = (_: GlossaryProps) => {
  return null;
};

export default Glossary;
